var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00269C0 5.26396 0.218718 5.4851 0.482407 5.4851H4.52027V9.52297C4.52027 9.78127 4.74143 10.0054 5.00269 10.0054C5.26396 10.0054 5.47972 9.78127 5.47972 9.52297V5.4851H9.52298C9.78128 5.4851 10 5.26396 10 5.00269C10 4.74141 9.78128 4.52028 9.52298 4.52028H5.47972V0.48241C5.47972 0.224094 5.26396 0 5.00269 0C4.74143 0 4.52027 0.224094 4.52027 0.48241V4.52028H0.482407C0.218718 4.52028 0 4.74141 0 5.00269Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0def9935b52a8d15abe4b3c8c577131a.svg";
export { ForwardRef as ReactComponent };